const isPayloadObject = (payload) => typeof payload === "object" && payload !== null;

const getRequestId = (payload) => (isPayloadObject(payload) ? payload.requestId : null);

const isOutdatedRequest = (payload, activeRequestId) => {
  const requestId = getRequestId(payload);
  return requestId !== null && requestId !== undefined && requestId !== activeRequestId;
};

const getInstruments = (payload) => {
  if (!isPayloadObject(payload)) {
    return payload;
  }

  return payload.instruments || [];
};

const getError = (payload) => (isPayloadObject(payload) ? payload.error : payload);

export const setLoadingInstruments = (state, payload) => {
  const loading = isPayloadObject(payload) ? payload.loading : payload;
  const requestId = getRequestId(payload);

  // Only the active request can clear loading state.
  if (!loading && isOutdatedRequest(payload, state.filteredInstruments.activeRequestId)) {
    return state;
  }

  return {
    ...state,
    filteredInstruments: {
      ...state.filteredInstruments,
      loading,
      activeRequestId: loading ? requestId : state.filteredInstruments.activeRequestId,
    },
  };
};

export const loadFilteredInstruments = (state, payload) => {
  if (isOutdatedRequest(payload, state.filteredInstruments.activeRequestId)) {
    return state;
  }

  return {
    ...state,
    filteredInstruments: {
      ...state.filteredInstruments,
      instruments: getInstruments(payload),
      error: null,
    },
  };
};

export const setInstrumentsError = (state, payload) => {
  if (isOutdatedRequest(payload, state.filteredInstruments.activeRequestId)) {
    return state;
  }

  return {
    ...state,
    filteredInstruments: {
      ...state.filteredInstruments,
      error: getError(payload),
    },
  };
};
